export const ISO8601ToTime = (isoString: string) => {
  // Регулярное выражение для извлечения часов и минут
  const regex = /PT(?:(\d+)H)?(?:(\d+)M)?/;
  const match = isoString.match(regex);

  if (!match) {
    throw new Error('Неверный формат строки');
  }

  // Извлечение часов и минут
  const hours = match[1] ? parseInt(match[1], 10) : 0;
  const minutes = match[2] ? parseInt(match[2], 10) : 0;

  // Форматирование времени в строку HH:MM
  const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  return formattedTime;
};
